module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row columns"
  }, [_c('div', {
    staticClass: "large-6 large-centered"
  }, [_c('div', {
    staticClass: "row columns"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "large-6 columns"
  }, [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cost),
      expression: "cost"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "step": "10000"
    },
    domProps: {
      "value": (_vm.cost)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cost = $event.target.value
      }
    }
  })])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row columns"
  }, [_c('div', {
    staticClass: "large-12 columns"
  }, [_c('div', {
    staticClass: "note text-left"
  }, [_vm._v("Cette partie permet de modifier le coût du joueur utilisé pour le calcul de TV")]), _vm._v(" "), _c('div', {
    staticClass: "note text-left"
  }, [_vm._v("En gros cela vous permet de fixer le coût en TV des modifications que vous avez fait")]), _vm._v(" "), _c('div', {
    staticClass: "note text-left"
  }, [_vm._v("Si vous avez mis des Xp, les augmentations générées auront leur propre coût")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "large-6 columns"
  }, [_c('h6', [_vm._v("Saisir le cout additionnel en pièce d'or")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d1dc377"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/team/team-customize-modals/cost-customizer.vue
// module id = 763
// module chunks = 0